import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TOSModal from './TOSModal';

function TOSWrapper({ children }) {
  const { user, refreshUser } = useAuth();
  const location = useLocation();
  const [showTOSModal, setShowTOSModal] = useState(false);

  useEffect(() => {
    // Don't show modals on reset-password page
    const isResetPassword = location.pathname.startsWith('/reset-password');
    if (isResetPassword) {
      setShowTOSModal(false);
      return;
    }

    // Test user IDs (FF8 characters)
    const testUserIds = [13, 14, 15, 16, 17, 18]; // SquallLeonhart, QuistisTrepe, ZellDincht, SelphieTilmitt, IrvineKinneas, RinoaHeartilly
    
    // Check if user is a test user and hasn't accepted ToS
    if (user && testUserIds.includes(user.id)) {
      // Test users must accept ToS
      if (user.tos_accepted === false) {
        setShowTOSModal(true);
      } else {
        setShowTOSModal(false);
      }
    } else {
      // Non-test users don't need the modal
      setShowTOSModal(false);
    }
  }, [user, location.pathname]);

  const handleAcceptTOS = async () => {
    try {
      const API_BASE = process.env.REACT_APP_API_BASE || '';
      const response = await fetch(`${API_BASE}/api/users/accept-tos`, {
        method: 'POST',
        credentials: 'include',
      });

      if (response.ok) {
        // Refresh user data to get updated TOS status
        await refreshUser();
        setShowTOSModal(false);
      } else {
        throw new Error('Failed to accept TOS');
      }
    } catch (error) {
      console.error('Error accepting TOS:', error);
      throw error;
    }
  };

  return (
    <>
      {children}
      {showTOSModal && <TOSModal onAccept={handleAcceptTOS} />}
    </>
  );
}

export default TOSWrapper;
